import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import { createPinia } from 'pinia'
import RootApp from './Layout/App.vue'
import Api from './Util/api'
import init from './Util/init'
import { dynamicRouterMixin } from '@/Layout/DynamicRouter.vue'

window.appApi=Api;

var VueApp=createApp(RootApp)


var VueComponents = {};
var VueStores = {};
var vueComponentList = [
  require.context(".", true, /.+\.vue$/),
];

for(let vueComponentListItem of vueComponentList)
  for(let key of vueComponentListItem.keys()) {
    let actualKey=key.replace(/\.vue|.*\//g, "");
    let actualComponent=vueComponentListItem(key).default;
    VueComponents[actualKey]=actualComponent;
    VueApp.component(actualKey, actualComponent);
  }

var Pinia=createPinia({});
VueApp.use(Pinia);

var storeList = [
  require.context("./Stores", false, /.+\.js$/),
];
for(let storeListItem of storeList) {
  for(let key of storeListItem.keys()) {
    let actualKey=key.replace(/\.js|.*\//g, "");
    let actualExport=storeListItem(key).default;
    VueStores[actualKey]=actualExport();
  }
}
VueApp.mixin({data: ()=>({
  stores: VueStores,
  dynRouter: dynamicRouterMixin,
})});


var VueRouter=createRouter({
  history: createWebHistory("/admin"),
  routes: [
//     {path: "/demo/storage", name: "demo.storage", component: VueComponents["DataFiles"]},
    {path: "/login", name: "login", component: VueComponents["Login"]},
    {path: "/:path*", name: "page", component: VueComponents["DynamicRouter"]},
  ],
});

for(var initMethod in init) {
  init[initMethod]({app: VueApp, stores: VueStores, components: VueComponents});
}

VueApp.use(VueRouter);

VueApp.mount(document.querySelector('#app'))

window.VueApp = VueApp
